/**
 * By li si yi
 * 业务维护弹出框组件--添加-编辑
 */
import React, {Component} from 'react';
import {Modal, Button, message, Switch, Form, Input} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {validateName} from "../../../../utils";

const {TextArea} = Input;
export default class AddAndInfoModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            currentClick: {},
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div>
                {this.renderModal()}
            </div>
        )
    };

    // 弹框
    renderModal = () => {
        let {dataSource, columns} = this.props;
        let {businessStatus, currentClick} = this.state;
        return (
            <div style={{display: 'flex'}}>
                <div>
                    <Modal
                        className={'deptLoginModal'}
                        title={!currentClick.id ? "新建业务" : "业务信息"}
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        centered={true}
                        width={800}
                        style={{alignSelf: 'center'}}
                        maskClosable={false}
                    >
                        <div>
                            <Form labelCol={{span: 4}} wrapperCol={{span: 19}}>
                                <Form.Item label="业务名称" required={true} message={"未填写业务名称！"}>
                                    <Input maxLength={50} placeholder={"请输入业务名称"}
                                           value={currentClick.name}
                                           onChange={(e) => {
                                               // console.log(e.target.value);
                                               this.setState({
                                                   currentClick: {
                                                       ...currentClick,
                                                       name: e.target.value
                                                   }
                                               })
                                           }}
                                    />
                                </Form.Item>

                                <Form.Item label="业务编码" required={true} message={"未填写业务编码！"}>
                                    <Input
                                        disabled={currentClick.id ? true : false}
                                        placeholder={"请输入业务编码"}
                                        value={currentClick.code}
                                        onChange={(e) => {
                                            // console.log(e.target.value);
                                            this.setState({
                                                currentClick: {
                                                    ...currentClick,
                                                    code: e.target.value
                                                }
                                            })
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item label="描述" style={{marginTop: '3px'}}>
                                    <TextArea rows={4} maxLength={200}
                                              placeholder={"请输入描述信息"}
                                              value={currentClick.desc}
                                              onChange={(e) => {
                                                  // console.log(e.target.value);
                                                  this.setState({
                                                      currentClick: {
                                                          ...currentClick,
                                                          desc: e.target.value
                                                      }
                                                  })
                                              }}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </Modal>
                </div>
            </div>
        )
    };
    // 显示
    showModal = ({
                     item = {}, callBack = () => {
        }
                 }) => {
        this.callBack = callBack;
        this.setState({
            visible: true,
            currentClick: item,
        });
    };
    // 确定
    handleOk = (callback) => {
        let {currentClick} = this.state;
        message.destroy();
        if (!currentClick.id) {
            // 添加
            let url = '/cm-sites-sys/businessModule/add';
            let params = {
                name: this.state.currentClick.name,
                code: this.state.currentClick.code,
                desc: this.state.currentClick.desc,
                message: "业务添加成功"
            };
            if (!params.name) {
                message.error("业务名称不能为空！")
                return false
            }
            if (!validateName(params.name, {min: 1, max: 50})) {
                message.error("业务名称最多50个字符，可使用中文、数字、字母、英文句号、下划线！");
                return false;
            }
            if (!params.code) {
                message.error("业务编码不能为空！");
                return false
            }
            if (!(/^[0-9a-zA-Z:_]{1,100}$/.test(params.code))) {
                message.error("业务编码只可填写字母、数字、下划线及冒号，限制输入100个字符！");
                return false;
            }
            this.addBusiness(params, url);
        } else {
            // 编辑
            let url = '/cm-sites-sys/businessModule/edit';
            let params = {
                name: this.state.currentClick.name,
                code: this.state.currentClick.code,
                id: this.state.currentClick.id,
                desc: this.state.currentClick.desc,
                message: "业务修改成功"
            };
            if (!params.name) {
                message.error("业务名称不能为空！")
                return false
            }
            this.addBusiness(params, url);
        }
        this.setState({
            visible: false,
        });
    };

    // 添加and编辑
    addBusiness = (params, url) => {
        this.request({
            url: url,
            method: 'post',
            body: params,
            callBack: (res) => {
                console.log(res);
                if (res) {
                    this.callBack && this.callBack()
                }
                message.success(params.message)
            },
            errorCallBack: (e) => {
                console.log(e)
            },
        });
    };

    // 取消
    handleCancel = e => {
        // console.log(e);
        this.setState({
            visible: false,
        });
    };
};

AddAndInfoModal.defaultProps = {
    currentClick: {
        name: "",
        code: "",
        desc: "",
    }
};
AddAndInfoModal.propTypes = {};